<div fullpage id="fullpage" [options]="config" (ref)="getRef($event)">
  <div class="section s1">
    <div class="container">
      <h1>Abdoul Aziz<br />Dione</h1>
      <p>Developpeur web - mobile</p>
    </div>
  </div>
</div>